<template>
  <div class="bmi-content" id="nav-id-0">
    <div class="title">身体简报</div>
    <div class="gray-content">
      <div class="b-title">
        <div class="name">身体质量指数(BMI)</div>
        <div class="num">{{ info.bmi }}</div>
      </div>
      <div class="bmi">
        <div class="bmi-flag" :style="{ left: bmiLeft }"></div>
        <div class="bmi-item" v-for="(item, index) in bmiList" :key="index">
          <div class="item-label">
            <div class="label">{{ item.label }}</div>
            <div class="num">{{ item.range }}</div>
          </div>
        </div>
      </div>
      <div class="b-desc">{{ info.bodyMassResult }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      bmiList: [
        {
          min: 16,
          max: 18.5,
          label: '偏瘦',
          range: '＜18.5'
        },
        {
          min: 18.5,
          max: 24,
          label: '正常',
          range: '18.5-24'
        },
        {
          min: 24,
          max: 28,
          label: '超重',
          range: '24-28'
        },
        {
          min: 28,
          max: 35,
          label: '肥胖',
          range: '≥28'
        }
      ]
    }
  },
  computed: {
    bmiLeft() {
      let index //位于第几阶段
      for (let i = 0; i < this.bmiList.length; i++) {
        let item = this.bmiList[i]
        if (this.info.bmi >= item.min && this.info.bmi < item.max) {
          index = i
        }
      }
      //占某个阶段的比例
      let per = 0
      if (index !== undefined) {
        per =
          (this.info.bmi - this.bmiList[index].min) /
          (this.bmiList[index].max - this.bmiList[index].min)
      }
      if (index === undefined) {
        index = this.info.bmi < this.bmiList[0].min ? 0 : this.bmiList.length
      }
      let res = (100 / this.bmiList.length) * (index + per)
      return res.toFixed(2) + '%'
    }
  }
}
</script>
<style lang="scss" scoped>
.bmi-content {
  width: 335px;
  box-sizing: border-box;
  margin: 0 auto 20px;
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;

  .title {
    position: relative;
    z-index: 1;
    display: inline-block;
    font-size: 22px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 28px;
    height: 28px;
    margin-bottom: 22px;
  }

  .title::after {
    position: absolute;
    z-index: -1;
    left: 0;
    bottom: 0;
    content: '';
    width: 100%;
    height: 7px;
    background: linear-gradient(
      270deg,
      rgba(190, 182, 254, 0) 0%,
      #897ffc 100%
    );
    opacity: 0.7;
  }

  .gray-content {
    background-color: rgba(244, 246, 250, 0.9);
    border-radius: 8px;
    padding: 16px 15px 19px;

    .b-title {
      display: flex;
      align-items: center;
      margin-bottom: 27px;

      .name {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        font-size: 15px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 21px;
      }

      .num {
        font-size: 20px;
        font-family: DIN;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 26px;
      }
    }

    .b-desc {
      margin-top: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 20px;
    }

    .bmi {
      height: 7px;
      background: linear-gradient(
        90deg,
        #fc6182 0%,
        #897ffc 26%,
        #897ffc 75%,
        #fd6181 100%
      );
      border-radius: 12px;
      display: flex;
      margin-bottom: 60px;
      position: relative;
      .bmi-flag {
        position: absolute;
        left: 0;
        z-index: 1;
        top: 50%;
        box-sizing: border-box;
        transform: translate(-50%, -50%);
        width: 11px;
        height: 11px;
        background: #ffffff;
        border-radius: 50%;
        border: 2px solid #897ffc;
      }

      .bmi-item {
        position: relative;
        flex: 1;
        box-sizing: border-box;
        border-right: 1px solid #fff;
      }

      .bmi-item:last-child {
        border-right: none;
      }

      .item-label {
        position: absolute;
        top: 16px;
        width: 100%;
        left: 0;
        text-align: center;

        .label {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 17px;
        }

        .num {
          font-size: 9px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 13px;
        }
      }
    }
  }
}
</style>
